export default "/images/vendor/@alquiler-argentina/aa-componentes/es/logo-none.svg?56fdb83caa3ee4b0877e226f630d53de";